
    <i
      class="fa fa-2x fa-arrow-circle-o-right text-dark"
      (click)="back($event)"
    ></i>
  